import { Tooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";
import { formatting } from "@north-beam/nb-common";

import { KpiType, type Kpi } from "../client-setting/types";

import { useReferencePerformance } from "./use-reference-performance";

export function HistoricalValueSummarySection({
  historicalValue,
  kpi,
}: {
  historicalValue?: number;
  kpi: Kpi | null;
}) {
  const { user } = useUser();

  const { isForecastSpend } = useReferencePerformance();

  const formatNonCurrencyApproximate = (value: number) => {
    return formatting.formatMetric(value, "integer", {
      precision: "approximate",
    });
  };

  const formatCurrencyToDollarAmount = (amount: number) => {
    return formatting
      .formatCurrency(amount, {
        precision: "exact",
        code: user.currencies.currentCurrency,
      })
      .replace(/\.[0-9][0-9]/, "");
  };

  const isValueTypeRevenue = kpi?.kpi_type === KpiType.REVENUE;

  const formatValueApproximate = (value: number) => {
    return isValueTypeRevenue
      ? formatCurrencyToDollarAmount(value)
      : formatNonCurrencyApproximate(value);
  };

  return (
    <div className="flex items-center justify-between w-full p-3">
      <div className="h-full w-full flex flex-col items-start flex-[1_0_0]">
        <div className="flex justify-start items-center w-full gap-2">
          <Tooltip
            placement="right"
            noInfoCircle
            content={kpi?.friendly_name}
            showTooltip={(kpi?.friendly_name?.length ?? 0) > 22}
            className="text-xs font-semibold uppercase mb-1 whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[180px]"
          >
            {kpi?.friendly_name}
          </Tooltip>
          <div className="flex justify-start items-center gap-1 mb-1">
            <i className="fa-regular fa-check text-alien text-xxs" />
            <span className="text-xs text-gray+1">
              {isForecastSpend ? "Forecast" : "Historical Actual"}
            </span>
          </div>
        </div>
        <div className="text-xl text-alien font-semibold flex-grow">
          {historicalValue || historicalValue === 0
            ? formatValueApproximate(historicalValue)
            : "No data"}
        </div>
      </div>
    </div>
  );
}
